import './Offer.css';

// React import
import React, { useState, useEffect } from 'react';

// Generic import
import _ from 'lodash';
import axios from 'axios';
import queryString from 'query-string';

// Local import
import OfferOpportunityOneOff from './Offer.opportunity.oneoff.js';
import OfferOpportunityContract from './Offer.opportunity.contract.js';
import OfferNotFound from './Offer.notfound.js';
import OfferGone from './Offer.gone.js';
import OfferAccessTokenError from './Offer.accesstokenerror.js';

function OfferOpportunity(props) {
    const parsed = queryString.parse(window.location.search);
    const { temporaryAccesstoken, previewKey } = parsed;
    const [ org, setOrg ] = useState(null);
    const [ account, setAccount ] = useState(null);
    const [ opportunity, setOpportunity ] = useState(null);
    const [ status, setStatus ] = useState(null);
    const [ exchangeRates, setExchangeRates ] = useState(null);
    const [ selected, setSelected ] = useState([]);
    const [ html, setHtml ] = useState(null);
    const [ notFound, setNotFound ] = useState(false);
    const [ gone, setGone ] = useState(false);
    const [ accessTokenError, setAccessTokenError ] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                let data, _exchangeRates;
                
                if (previewKey) {
                    // Load preview data from sessionStorage
                    const previewDataStr = sessionStorage.getItem(previewKey);
                    if (!previewDataStr) {
                        setNotFound(true);
                        return;
                    }
                    const previewData = JSON.parse(previewDataStr);
                    data = {
                        opportunity: previewData.opportunity,
                        html: previewData.html,
                        org: previewData.org,
                        account: previewData.account,
                    };
                    _exchangeRates = previewData.exchangeRates;
                } else {
                    // Use temporary access token to fetch from API
                    const [{ data: renderData }, { data: exchangeRatesData }] = await Promise.all([
                        axios.post(`/api/opportunities/render?temporaryAccesstoken=${temporaryAccesstoken}`, {}),
                        axios(`/api/opportunities/exchange-rates?temporaryAccesstoken=${temporaryAccesstoken}`),
                    ]);
                    data = renderData;
                    _exchangeRates = exchangeRatesData;
                }
                
                setExchangeRates(_exchangeRates);
                setOpportunity(data.opportunity);
                setStatus(data.opportunity.status);
                setAccount(data.account);
                setOrg(data.org);
                setHtml(data.html);
                setSelected(parsed.pdf || parsed.print ? [] : data.opportunity.selected || _.compact([
                    data.opportunity.offers[0]?.id,
                    ..._.flatten(data.opportunity.offers?.map(o => o.sections?.map(s => s.offers[0].id)))
                ]));
                if (parsed.print) {
                    setTimeout(() => window.print(), 2000);
                }
            } catch(e) {
                if (e.response?.status === 404) {
                    setNotFound(true);
                } else if (e.response?.status === 410) {
                    setGone(true);
                } else if (e.response?.status === 400) {
                    setAccessTokenError(true);
                } else {
                    throw e;
                }
            }
        })();
    }, [ temporaryAccesstoken, previewKey ]);

    if (notFound) {
        return (
            <OfferNotFound />
        );
    }

    if (gone) {
        return (
            <OfferGone />
        );
    }

    if (accessTokenError) {
        return (
            <OfferAccessTokenError />
        );
    }

    if (!exchangeRates || !opportunity) return null;

    if (opportunity.type === 'one-off' || opportunity.type === 'one-off-email' || opportunity.type === 'one-off-free-text') {
        return (
            <OfferOpportunityOneOff
                org={org} 
                html={html}
                opportunity={opportunity} 
                exchangeRates={exchangeRates} 
                status={status} 
                setStatus={setStatus} 
                selected={selected}
                setSelected={setSelected}
                {...parsed} 
            />
        );
    } else if (opportunity.type === 'contract') {
        return (
            <OfferOpportunityContract
                org={org} 
                html={html}
                account={account} 
                opportunity={opportunity} 
                exchangeRates={exchangeRates} 
                status={status} 
                setStatus={setStatus} 
                selected={selected}
                setSelected={setSelected}
                {...parsed} 
            />
        );
    }
}

export default OfferOpportunity;
